var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "baseline", dense: "" } },
    [
      _vm._t("label", function () {
        return [
          _vm.label && !_vm.hideLabel
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: _vm.labelSize } },
                [
                  _c(
                    "v-card",
                    { staticClass: "d-flex", attrs: { flat: "" } },
                    [
                      _c("v-card", { attrs: { flat: "" } }, [
                        _c(
                          "span",
                          {
                            class:
                              "subtitle-2 " +
                              (_vm.focused ? "primary--text" : ""),
                          },
                          [_vm._v(" " + _vm._s(_vm.label) + " ")]
                        ),
                        _vm.hint
                          ? _c("div", [
                              _c("span", { staticClass: "text-caption" }, [
                                _vm._v(_vm._s(_vm.hint)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _c("v-col", { staticClass: "grow" }, [_vm._t("default")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }